module.exports = __webpack_public_path__ + "img/KSC00484.9db4de2c.jpg";